module.exports = __webpack_public_path__ + "static/media/redessociais.1a6383cb.svg";